import React from 'react';
import styles from './EditAccountCurrencyModal.module.scss';
import { ReactComponent as ApprovalStepInfo } from './assets/edit-processing-currency-summary-info.svg';
import { ReactComponent as RightArrow } from './assets/right-arrow.svg';
import { ExternalLinks } from 'shared/enums/external-links.enum';
import { Currency } from 'shared/components/CurrencySelect/types';

interface ApprovalStepProps {
  isMsp: boolean;
  providerCurrency: Currency;
  newProcessingCurrency: Currency;
}

export const ApprovalStep: React.FC<ApprovalStepProps> = ({ isMsp, providerCurrency, newProcessingCurrency }) => {
  return (
    <div className={styles.approvalContainer}>
      <div className={styles.changeSummary}>
        <div className={styles.billingCurrency}>
          <div className={styles.left}>
            <div>Provider Currency:</div>
            <div>
              <b>{providerCurrency?.code}</b>
            </div>
          </div>

          <div className={styles.right}>
            <div className={styles.currencySymbol}>{providerCurrency?.symbolNative}</div>
          </div>
        </div>
        <RightArrow />
        <div className={styles.newProcessingCurrency}>
          <div className={styles.left}>
            <div>Processing Currency:</div>
            <div>
              <b>{newProcessingCurrency?.code}</b>
            </div>
          </div>
          <div className={styles.right}>
            <div className={styles.currencySymbol}>{newProcessingCurrency?.symbolNative}</div>
          </div>
        </div>
      </div>
      <div className={styles.pointOne}>
        <ApprovalStepInfo className={styles.infoIcon} />

        <div className={styles.infoText}>
          The currency change applies to <b>all users</b> with access to this account{' '}
          {isMsp ? '(including your customers)' : null}.
        </div>
      </div>
      <div className={styles.pointTwo}>
        <ApprovalStepInfo className={styles.infoIcon} />
        <div className={styles.infoText}>Update the currency for existing Event Rules manually.</div>
      </div>
      <div className={styles.pointThree}>
        <ApprovalStepInfo className={styles.infoIcon} />
        <div className={styles.infoText}>
          <div>Reminder, the processing currency is relevant in the following pages:</div>
          <ul className={styles.infoPoints}>
            <li> Main Dashboard</li>
            <li> Cost and Usage section</li>
            <li> Partner section: Reports, Billing History, and Billing Status pages</li>
          </ul>
        </div>
      </div>
      <div className={styles.learnMore}>
        <a
          href={ExternalLinks.CurrenciesDocumentation}
          target="_blank"
          className={styles.navigateText}
        >
          Learn more
        </a>
      </div>
    </div>
  );
};
